export function applyClientPayload({
  client,
  latencyWindowSize = 20,
  payload,
  propertyParts,
  receivedTimestamp,
  skipLatency = false,
  topic,
}) {
  client.inboundMessageCount = (client.inboundMessageCount || 0) + 1
  // Backward compatibility for callers still reading messageCount.
  client.lastMessage = { payload, topic }
  client._topicParts = topic.split('/')
  client.baseTopic = client._topicParts
    .slice(0, client._topicParts.indexOf(client.id) + 1)
    .join('/')

  const path =
    Array.isArray(propertyParts) && propertyParts.length > 0
      ? propertyParts
      : ['data']

  let target = client
  for (let i = 0; i < path.length - 1; i++) {
    const part = path[i]
    if (
      !(part in target) ||
      typeof target[part] !== 'object' ||
      target[part] === null
    ) {
      target[part] = {}
    }
    target = target[part]
  }

  const lastKey = path.at(-1)
  target[lastKey] = payload

  if (path[0] === 'heartbeat') {
    const payloadTimestamp = getPayloadTimestamp(payload)
    if (payloadTimestamp) {
      client.lastSeen = payloadTimestamp
    }
  }

  if (!skipLatency) {
    updateLatency({
      client,
      latencyWindowSize,
      payload,
      receivedTimestamp,
    })
  }
}

export function updateLatency({
  client,
  latencyWindowSize = 20,
  payload,
  receivedTimestamp,
}) {
  if (!client) {
    return
  }

  const payloadTime =
    typeof payload?.timestamp === 'string'
      ? Date.parse(payload.timestamp)
      : typeof payload?.timestamp === 'number'
        ? payload.timestamp
        : null

  if (!payloadTime) {
    return
  }

  const latency = receivedTimestamp.getTime() - payloadTime
  if (latency <= 0 || latency > 5000) {
    return
  }

  if (!client.isFirstLatencyRecorded) {
    client.isFirstLatencyRecorded = true
    return
  }

  client.latencyHistory.push(latency)
  if (client.latencyHistory.length > latencyWindowSize) {
    client.latencyHistory.shift()
  }

  client.minLatency = Math.min(...client.latencyHistory)
  client.maxLatency = Math.max(...client.latencyHistory)
  const sum = client.latencyHistory.reduce((a, b) => a + b, 0)
  client.averageLatency = Math.round(sum / client.latencyHistory.length)
}

function getPayloadTimestamp(payload) {
  const value = payload?.timestamp ?? payload?.system?.local_datetime?.timestamp
  if (typeof value === 'number') {
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
  }
  if (typeof value !== 'string' || !value.trim()) {
    return null
  }

  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}
